import React, { useState, useContext, useMemo, createContext, useEffect } from 'react'

import qs from "qs"

import userPermissions from "../../../User/Permissions"

import { ScreenContext } from '../..'
import {
    DataGridPro,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    ptBR,
    getGridStringOperators,
    GridToolbarExportContainer,
    getDataGridUtilityClass,
    getGridDateOperators,
    getGridSingleSelectOperators,
    gridClasses,
    useGridApiRef,
    useGridApiContext,
    useGridSelector,
    gridFilteredDescendantCountLookupSelector,
    getGridNumericOperators
} from '@mui/x-data-grid-pro';

import { GridToolbarImportClients } from './ClientContainer/GridToolbarImportClients';

import { ptBR as corePtBR } from '@mui/material/locale';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { useTelephony } from '../../../../contexts/TelephonyContext';
import GroupBadge from '../../../Groups/GroupBadge';

import {
    Box,
    Button,
    Chip,
    ListItem,
    Tooltip,
    IconButton,
    FormControlLabel,
    Switch,
    Skeleton,
    TextField,
    InputAdornment,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Paper,
    Checkbox,
    List,
    ListItemButton,
    ListItemText,
    Typography,
    Link
} from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import LoadingButton from '@mui/lab/LoadingButton';
import ClientGroupButton from './ClientGroupButton';
import ClientDialog from '../../../Dialogs/Client';
import ConfirmationDialog from '../../../Dialogs/Confirmation';
import MergeClientDialog from '../../../Dialogs/MergeClient';
import CustomFieldsDialog from '../../../Dialogs/CustomFields';
import api from '../../../../api';
import useNotification from '../../../Notification';
import AddClientGroupForm from './AddClientGroupForm';
import EditGroupNameModal from './EditGroupNameModal';
import EditGroupMembersModal from './EditGroupMembersModal';
import BulkEditContactDialog from '../../../Dialogs/BulkEditContact';
import AddClient from '../../TabButtons/AddClient';
import ImportClients from '../../TabButtons/ImportClients';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Information from '../../TabButtons/Information';
import ConfirmationDialogCaptcha from '../../../Dialogs/ConfimationDialogCaptcha';
import PhoneIcon from '@mui/icons-material/PhoneAndroid';
import PhoneCallIcon from '@mui/icons-material/Phone';
import { getSession } from '../../../../auth';
import isMobile from '../../../../utils/isMobile';
import normalizeHttpUrl from '../../../../utils/normalizeHttpUrl';
import ContactCard from "../../ContactCard"
import Event from "../../../Agenda/Event"
import { getFilterInputPlaceholderByField } from "../filterPlaceholder"

import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import TelegramIcon from '@mui/icons-material/Telegram';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import MicrosoftIcon from '@mui/icons-material/Groups';
import EmailIcon from '@mui/icons-material/Email';
import ReceiptIcon from '@mui/icons-material/Receipt';
import GroupIcon from '@mui/icons-material/GroupAdd';
import SettingsIcon from '@mui/icons-material/Settings';
import TableRowsIcon from '@mui/icons-material/TableRows';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import SearchIcon from "@mui/icons-material/Search"
import EventIcon from "@mui/icons-material/Event"
import SmsIcon from "@mui/icons-material/Sms"
import WorkIcon from "@mui/icons-material/Work"

import Templates from "../../Templates"
import SendEmail from "../../TabButtons/SendMessage/SendEmail"
import { OpportunityByContact } from "../../../Journeys/OpportunityByContact"

import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'

import './styles.css'
import UserChats from './UserChats';
import ContactChannels from './ContactChannels';
import { replaceMCDU } from '../../../Settings/Vivre/Vivremenu/replaceMCDU';
import SendSMS from '../../TabButtons/SendMessage/SendSMS';

const userGroups = userPermissions()

const renderBooleanCustomField = (value) => {
    if (value === null || value === undefined || value === '') return ''

    const normalized = String(value).trim().toLowerCase()
    if (['1', 'true', 'sim'].includes(normalized)) return 'Sim'
    if (['0', 'false', 'não', 'nao'].includes(normalized)) return 'Não'
    return ''
}

const parseFilters = (filterModel, type = "object") => {
    let filterString = filterModel.items.map(each => {
        const columnField = encodeURIComponent(each.columnField)
        if (each.value)
            return (`&${columnField}__${each.operatorValue}=${encodeURIComponent(each.value)}`)
        if (["is_empty", "isEmpty"].includes(each.operatorValue))
            return (`&${columnField}__is_empty=true`)
        if (["is_not_empty", "isNotEmpty"].includes(each.operatorValue))
            return (`&${columnField}__is_not_empty=true`)
    }).join("")
    if ("linkOperator" in filterModel && filterModel.linkOperator == "or")
        filterString += "&or=True"
    if (type == "object") {
        const filters = {}
        const params = new URLSearchParams(filterString.startsWith("&") ? filterString.slice(1) : filterString)
        for (const [key, value] of params.entries()) {
            if (filters.hasOwnProperty(key))
                filters[key] = Array.isArray(filters[key]) ? [...filters[key], value] : [filters[key], value]
            else
                filters[key] = value
        }
        return filters
    }
    return filterString
}

const parseSort = (sortModel, type = "object") => {
    const sortString = sortModel.map(each => (`&sort=${each.field}__${each.sort}`)).join('')
    if (type == "object")
        return Object.fromEntries(new URLSearchParams(sortString.startsWith("&") ? sortString.slice(1) : sortString).entries())
    return sortString
}

function CustomGridTreeDataGroupingCell(props: GridRenderCellParams) {
    const { id, field, rowNode } = props;
    const apiRef = useGridApiContext();
    const filteredDescendantCountLookup = useGridSelector(
        apiRef,
        gridFilteredDescendantCountLookupSelector,
    );
    const filteredDescendantCount = filteredDescendantCountLookup[rowNode.id] ?? 0;

    const handleClick: ButtonProps['onClick'] = (event) => {
        apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
        apiRef.current.setCellFocus(id, field);
        event.stopPropagation();
    };

    return (
        <Box sx={{ ml: rowNode.depth * 4 }}>
            <div>
                {filteredDescendantCount > 0 ? (
                    <Button onClick={handleClick} tabIndex={-1} size="small">
                        {props.formattedValue} ({filteredDescendantCount})
                    </Button>
                ) : (
                    <span />
                )}
            </div>
        </Box>
    );
}



const ClientsTable = ({ loadMoreGroups }) => {

    const {
        isSmallScreen,
        enterpriseId,
        settings,
        clients,
        updateClients,
        updateReady,
        updateGroups,
        updateCampaigns,
        groups,
        customFields,
        rmvObj,
        subsObj,
        updateSelectedModel,
        ServerData,
        getClients,
        updateLimitOffset,
        limitOffset,
        filterModel,
        sortModel,
        permissions,
        selectedNumberModel,
        updateNumberSelectedModel,
        getCustomFields,
        templates,
        queues,
        originNumbers,
        setProfile,
        selectedView,
        profile,
        usersEmails,
        myTeam
    } = useContext(ScreenContext)

    const { callContact, initiateCall } = useTelephony();

    const [editClientDialog, updateEditClientDialog] = useState(false)
    const [deleteClientDialog, updateDeleteClientDialog] = useState(false)
    const [massDeleteClientDialog, updateMassDeleteClientDialog] = useState(false)
    const [massBulkEditContactDialog, updateMassBulkEditContactDialog] = useState(false)
    const [showAddClientGroupForm, updateShowAddClientGroupForm] = useState(false)
    const [deleteClientGroupModal, updateDeleteClientGroupModal] = useState(false)
    const [editClientGroupModal, updateEditClientGroupModal] = useState(false)
    const [editGroupMembersModal, updateEditGroupMembersModal] = useState(false)
    const [selectedClientModel, updateSelectedClientModel] = useState([])
    const [selectedClients, updateSelectedClients] = useState([])
    const [selectedClientGroup, updateSelectedClientGroup] = useState([])
    const [clientsFilter, updateClientsFilter] = useState({ items: [] })
    const [forceReload, updateForceReload] = useState(false)
    const [pageLimit, updatePageLimit] = useState(0)
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({ items: [] })
    const [clientsSort, updateClientsSort] = useState([])
    //const [usersEmails, updateUsersEmails] = useState([])
    const [showChats, setShowChats] = useState(null)
    const [mergeClientDialog, updateMergeClientDialog] = useState(false)
    const [groupedByEnterprise, setGroupedByEnterprise] = useState(false)
    const [showCustomFields, setShowCustomFields] = useState(false)
    const [showEditChannelDialog, setShowEditChannelDialog] = useState(null)
    const [clientsGrid, setClientsGrid] = useState(null)
    const [nextClientsGrid, setNextClientsGrid] = useState(null)
    const [loadMoreGrid, setLoadMoreGrid] = useState(false)
    const [singleClientWhatsAppNotify, setSingleClientWhatsAppNotify] = useState(null)
    const [singleClientSMSNotify, setSingleClientSMSNotify] = useState(null)
    const [singleClientEmailNotify, setSingleClientEmailNotify] = useState(null)
    const [clientsGridFilter, setClientsGridFilter] = useState(null)
    const [clientsTableFilter, setClientsTableFilter] = useState(null)
    const [debouncedValue, setDebouncedValue] = useState(null)
    const [tableDebouncedValue, setTableDebouncedValue] = useState(null)
    const [filterPlaceholderField, setFilterPlaceholderField] = useState("name")
    const [showCreateEvent, setShowCreateEvent] = useState(false)
    const [selectedContact, setSelectedContact] = useState(null)
    const [setup, setSetup] = useState(null)
    const [showCreateOpportunity, setShowCreateOpportunity] = useState(false)
    const [userJourneys, setUserJourneys] = useState(null)

    const handleAddClientGroupForm = () => {
        updateShowAddClientGroupForm(true)
    }
    const submitClientGroupForm = async () => {
        await updateSelectedClients([])
        updateNumberSelectedModel([])
        updateShowAddClientGroupForm(false)

    }
    const handleDeleteClientGroup = (value) => {
        updateDeleteClientGroupModal(true)
        updateSelectedClientGroup(value)
    }

    const apiRef = useGridApiRef()

    const GRID_LAYOUT_KEY = 'crmClientGridLayout_v1';
    const LEGACY_GRID_COLUMNS_KEY = 'crmClientGridColumns_v3';

    const optionalColumnSizes = {
        customer_code: { minWidth: 140 },
        internal_code: { minWidth: 180 },
        contact_enterprise_name: { minWidth: 180 },
        cpf: { minWidth: 140 },
        created_at: { minWidth: 170 },
        updated_at: { minWidth: 170 },
        birthday: { minWidth: 140 },
        linkedin_url: { minWidth: 200 },
        last_communication_date: { minWidth: 170 },
        notification_opt_out: { minWidth: 150 },
        no_disturb: { minWidth: 140 },
        organization_id: { minWidth: 160 },
    };

    const getColumnSize = (field) => {
        if (String(field).startsWith('custom_'))
            return { minWidth: 180 };

        return optionalColumnSizes[field] || {};
    };

    const getEmptyGridLayout = () => ({
        order: [],
        widths: {},
        visibility: {},
    });

    const migrateLegacyColumnsToLayout = () => {
        try {
            const legacyColumns = JSON.parse(localStorage.getItem(LEGACY_GRID_COLUMNS_KEY));

            if (!Array.isArray(legacyColumns) || legacyColumns.length === 0)
                return getEmptyGridLayout();

            const layout = {
                order: legacyColumns.map((column) => column.field),
                widths: legacyColumns.reduce((acc, column) => {
                    if (typeof column.width === 'number')
                        acc[column.field] = column.width;
                    return acc;
                }, {}),
                visibility: legacyColumns.reduce((acc, column) => {
                    acc[column.field] = !column.hide;
                    return acc;
                }, {}),
            };

            localStorage.setItem(GRID_LAYOUT_KEY, JSON.stringify(layout));
            localStorage.removeItem(LEGACY_GRID_COLUMNS_KEY);

            return layout;
        } catch (error) {
            return getEmptyGridLayout();
        }
    };

    const getGridLayout = () => {
        try {
            const savedLayout = JSON.parse(localStorage.getItem(GRID_LAYOUT_KEY));

            if (savedLayout) {
                return {
                    ...getEmptyGridLayout(),
                    ...savedLayout,
                    widths: savedLayout.widths || {},
                    visibility: savedLayout.visibility || {},
                    order: savedLayout.order || [],
                };
            }

            return migrateLegacyColumnsToLayout();
        } catch (error) {
            return getEmptyGridLayout();
        }
    };

    const saveGridLayout = (partialLayout) => {
        const currentLayout = getGridLayout();

        const nextLayout = {
            ...currentLayout,
            ...partialLayout,
            widths: {
                ...currentLayout.widths,
                ...(partialLayout.widths || {}),
            },
            visibility: {
                ...currentLayout.visibility,
                ...(partialLayout.visibility || {}),
            },
        };

        localStorage.setItem(GRID_LAYOUT_KEY, JSON.stringify(nextLayout));
    };

    const applyGridLayoutToColumns = (baseColumns) => {
        const layout = getGridLayout();
        const columnsMap = new Map(baseColumns.map((column) => [column.field, { ...column }]));

        const orderedFields = [];

        layout.order.forEach((field) => {
            if (columnsMap.has(field))
                orderedFields.push(field);
        });

        baseColumns.forEach((column) => {
            if (!orderedFields.includes(column.field))
                orderedFields.push(column.field);
        });

        return orderedFields.map((field) => {
            const column = {
                ...getColumnSize(field),
                ...columnsMap.get(field)
            };

            if (field in layout.visibility)
                column.hide = !layout.visibility[field];

            if (field in layout.widths) {
                column.width = layout.widths[field];
                delete column.flex;
            }

            return {
                ...column,
                ...dynamicColumnsProperties()[field]
            };
        });
    };

    useEffect(() => {
        const fetchUserJourneys = async () => {
            try {
                const response = await api.get(`/api/enterprises/${enterpriseId}/journeys/`)
                if (response.status === 200) {
                    const journeysData = response.data.results || response.data
                    setUserJourneys(journeysData)
                }
            } catch (error) {
                setUserJourneys([])
            }
        }
        fetchUserJourneys()
    }, [enterpriseId])

    const canCreateOpportunity = () => {
        if (!getSession()?.profile?.enterprise?.show_journey) {
            return false
        }
        if (permissions.isOperator && !permissions.isNotOnlyOperator) {
            return userJourneys && userJourneys.length > 0
        }
        return true
    }

    useEffect(() => {
        const handleColumnOrderChange = (params) => {
            const fields = getColumns().map((column) => column.field);

            const oldIndex = params.oldIndex - 1;
            const targetIndex = params.targetIndex - 1;

            if (
                oldIndex < 0 ||
                targetIndex < 0 ||
                oldIndex >= fields.length ||
                targetIndex >= fields.length
            ) {
                return;
            }

            const movedField = fields[oldIndex];
            fields.splice(oldIndex, 1);
            fields.splice(targetIndex, 0, movedField);

            saveGridLayout({ order: fields });
        };

        let unsubscribe;
        if (typeof apiRef.current?.subscribeEvent === "function")
            unsubscribe = apiRef.current.subscribeEvent("columnOrderChange", handleColumnOrderChange);

        return () => {
            if (typeof unsubscribe === 'function')
                unsubscribe();
        };
    }, [apiRef, isSmallScreen, usersEmails, customFields, clients.length]);

    useEffect(() => {
        updateSelectedModel(selectedClients)
        updateClientsFilter(filterModel.clients)
        updateClientsSort(sortModel.clients)
    }, [selectedClients])

    useEffect(() => {
        setColumnVisibilityModel({
            email: !isSmallScreen,
            created_at: !isSmallScreen,
            enterprise_name: false,
            enterprise_cnpj: false,
            updated_at: false,
            last_communication_date: false,
            channels: false
        })
    }, [isSmallScreen])

    const addSelectedClientsToGroup = async (selectedGroup) => {

        updateNumberSelectedModel([])
        updateReady(false)

        const payload = []
        selectedClients.forEach((client) => {
            payload.push({
                group_id: selectedGroup.id,
                contact_id: client
            })
        })

        const response = await api.post(`api/enterprises/${enterpriseId}/contact_group_contacts/bulk_create/`, payload)

        if (response.status === 201) {
            await getClients()
            useNotification(
                'Sucesso!',
                'Segmento atualizado!',
                'success'
            );
        } else {
            useNotification(
                'Ops!',
                'Algo deu errado, tente novamente',
                'danger'
            );
        }

        updateReady(true)
    }

    const submitDeleteClientGroupModal = async () => {
        updateReady(false)
        updateNumberSelectedModel([])

        const url = `/api/enterprises/${enterpriseId}/contact_group/${selectedClientGroup.id}/`;
        const response = await api.delete(url)

        if (response.status == 403) {
            useNotification(
                'Ops!',
                'Você não tem permissão para ver esse conteúdo',
                'danger'
            );
            return
        }

        updateGroups(prevState => rmvObj(prevState, selectedClientGroup.id))
        updateClients(prevState =>
            prevState.map(each => {
                each.groups = each.groups.filter(group => group.id !== selectedClientGroup.id)
                return each
            }))
        updateCampaigns(prevState =>
            prevState.map(each => {
                each.groups = each.groups.filter(group => group.group !== selectedClientGroup.id)
                return each
            }))


        useNotification(
            'Sucesso!',
            'Segmento deletado!',
            'success'
        );
        updateDeleteClientGroupModal(false)
        updateReady(true)
    }
    const handleEditClientGroup = (value) => {
        updateEditClientGroupModal(true)
        updateSelectedClientGroup(value)
    }

    const submitEditModal = async () => {
        updateNumberSelectedModel([])
        updateReady(false)
        updateReady(true)
        useNotification(
            'Sucesso!',
            'Segmento atualizado!',
            'success'
        );
    }

    const handleEditClientGroupMembers = (value) => {
        updateEditGroupMembersModal(true)
        updateSelectedClientGroup(value)
    }




    const showEditClientDialog = async (row) => {
        await updateSelectedClientModel(row)
        updateEditClientDialog(true)
    }
    const showDeleteClientDialog = (row) => {
        updateDeleteClientDialog(true)
        updateSelectedClientModel(row)
    }

    const isNumber = (n) => {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    const formatPhone = (telephone) => {
        let newTelephone = '';
        if (telephone) {
            const numberTelephone = telephone.replace(/[^0-9]+/g, '');
            if (numberTelephone.length < 10)
                return false
            if (isNumber(numberTelephone) && numberTelephone.substring(0, 3) !== '+55')
                newTelephone = `+55${numberTelephone}`;
            else
                newTelephone = telephone;
        }
        return newTelephone;
    }

    const changeClient = async (id, name, initialEmail, email, initialTelephone, telephone, userFields, advisor, contactEnterprise, cpf, customer_code, groups, contactCustomFields, toCreateCustomFields, notificationOptOut, owner) => {

        updateSelectedClientModel([]);
        updateNumberSelectedModel([])
        updateEditClientDialog(false);

        updateReady(false)
        const data = {
            name: '',
            email: '',
            telephone: '',
            enterprise_name: '',
            enterprise_cnpj: '',
            customer_code: '',
            notification_opt_out: false,
            owner: owner === '' ? null : owner
        };

        if (name)
            data['name'] = name;

        if (email)
            data['email'] = email;

        if (telephone) {
            const number = formatPhone(telephone)
            data['telephone'] = number
        }

        if (!name && !email && !telephone) {
            useNotification(
                'Ops!',
                `Insira pelo menos um: nome, email, ou telefone.`,
                'warning'
            )
            updateEditClientDialog(true)
            updateReady(true)
            return
        }

        if (userFields)
            data['user_fields'] = userFields;

        if (advisor)
            data['advisor'] = advisor;

        data['contact_enterprise'] = contactEnterprise

        if (cpf)
            data['cpf'] = cpf;

        if (customer_code)
            data['customer_code'] = customer_code;

        if (notificationOptOut)
            data['notification_opt_out'] = notificationOptOut

        data['groups'] = groups

        if (contactCustomFields.length !== 0)
            data['update_custom_fields'] = contactCustomFields

        if (toCreateCustomFields.length !== 0)
            data['create_custom_fields'] = toCreateCustomFields

        const res = await api.patch(`/api/enterprises/${enterpriseId}/contacts/${id}/`, data)

        updateReady(true)

        if (res.status === 206) {
            getClients()
            useNotification('Sucesso!', 'Cliente atualizado', 'success');
            return
        }

        if (res.status == 200) {
            const newclient = res.data
            const userId = getSession().id
            let newclients = clients.map(each => (each.id === newclient.id ? newclient : each))
            if (!permissions.isSupervisor) {
                newclients = newclients.filter(client => [null, userId].includes(client.owner))
            }
            updateClients(newclients)
            useNotification('Sucesso!', 'Cliente atualizado', 'success');
            return
        }

        if (res.status === 403) {
            useNotification(
                'Ops',
                `Você não pode alterar o dono desse contato.`,
                'danger'
            )
            return
        }



        if (res.status == 400 && 'advisor' in res.data) {
            useNotification(
                'Assessor não encontrado',
                `Email de assessor ${data['advisor']} não existe no nosso banco de dados`,
                'danger'
            )
            return
        }

        let message = 'Ocorreu um erro no sistema'
        if (res.data.detail == 'Não encontrado.')
            message = 'O cliente não foi encontrado.'

        if (res.data?.error?.cpf) {
            message = res.data.error.cpf[0]
        }
        else if (res.data?.error?.non_field_errors?.includes('The fields enterprise, email must make a unique set.')) {
            const name = res.data.contact?.owner__first_name ? `${res.data.contact.owner__first_name} ${res.data.contact.owner__last_name}` : 'Público'
            message = `Já existe um contato cadastrado com esse e-mail nessa conta e pertence ao usuário ${name}.`
        }
        else if (Array.isArray(res.data?.error) && res.data.error.includes('Enter a valid email address.')) {
            message = 'Utilize um e-mail válido.'
        }
        else if (res.status == 400) {
            const errorMessages = {
                'Invalid data type. Expected an integer.': 'deve conter um número.',
                'Invalid data type. Expected either 0 or 1.': 'deve conter Sim ou Não.',
                'Not a valid string.': 'Não é válido',
            };
            Object.keys(res.data).forEach((key) => {
                if (!Array.isArray(res.data[key]))
                    return

                res.data[key].forEach((error) => {
                    if (errorMessages[error])
                        message = `O campo ${key} ${errorMessages[error]}`;
                });
            })
        }

        useNotification('Ops!', message, 'danger');

        getClients()
    }

    const deleteClient = async (client) => {
        updateNumberSelectedModel([])
        updateReady(false)
        const res = await api.delete(`/api/enterprises/${enterpriseId}/contacts/${client.id}/`)
        updateReady(true)
        if (res.status == 204) {
            useNotification(
                'Sucesso!',
                'Cliente removido com sucesso',
                'success'
            );
            updateClients(clients.filter(each => client.id !== each.id))
            return
        }
        let message = 'Ocorreu um erro no sistema'
        if (res?.data?.detail == 'Não encontrado.')
            message = 'O cliente não foi encontrado.'
        useNotification(
            'Ops!',
            message,
            'danger'
        );
        getClients()
    }

    const bulkUpdateContacts = async ({ customerCode, contactEnterprise, owner, notificationOptOut, noDisturb, selectedGroups, customFieldsData }) => {
        const payload = { contact_ids: selectedClients }
        if (customerCode) payload.customer_code = customerCode
        if (contactEnterprise) payload.contact_enterprise = contactEnterprise.id
        if (owner === 'public') payload.owner = null
        else if (owner !== '') payload.owner = owner
        if (notificationOptOut !== '') payload.notification_opt_out = notificationOptOut === 'true'
        if (noDisturb !== '') payload.no_disturb = noDisturb === 'true'
        if (selectedGroups && selectedGroups.length > 0) payload.groups = selectedGroups.map(g => g.id)
        if (customFieldsData && Object.keys(customFieldsData).length > 0) payload.custom_fields = customFieldsData

        const response = await api.post(`api/enterprises/${getSession().profile.enterprise.id}/contacts/bulk_update/`, payload)
        if (response.status === 200) {
            updateMassBulkEditContactDialog(false)
            updateSelectedClients([])
            updateNumberSelectedModel([])
            await getClients()
            useNotification('Sucesso!', 'Contatos atualizados com sucesso.', 'success')
            return
        }
        useNotification('Ops!', 'Algo deu errado, tente novamente.', 'danger')
    }

    const deleteClients = async () => {
        updateNumberSelectedModel([])
        updateReady(false)
        const res = await api.post(`/api/enterprises/${enterpriseId}/contacts/bulk_delete/`, { clients_ids: selectedClients })
        updateReady(true)
        if (res.status == 204) {
            useNotification(
                'Sucesso!',
                'Contatos removidos com sucesso',
                'success'
            );
            await getClients()
            //updateClients(clients.filter(each => !selectedClients.includes(each.id)))
            return

        }
        let message = 'Ocorreu um erro no sistema'
        if (res.data.detail === 'Não encontrado.')
            message = 'Os contatos não foram encontrados.'
        if (res.data === "You can't delete when integrated with other CRM")
            message = 'Os contatos não podem ser deletados em massa pelo kwik, apenas pelo CRM integrado.'
        useNotification(
            'Ops!',
            message,
            'danger'
        );
        getClients()
    }


    const notifyNoPermission = () => {
        useNotification(
            'Ops!',
            'Você não tem permissão para executar essa ação.',
            'danger'
        );
    }

    const canChange = () => {
        if (getSession().profile.change_contacts
            || permissions.isAdmin
            || permissions.isSupervisor
            || permissions.isNotOnlyOperator
        ) {
            return true;
        }
        return false;
    }

    // Blocking sorting for integrations
    const sortable = true

    const filterOperators = getGridStringOperators().filter((operator) => ['contains', 'equals', 'startsWith', 'endsWith'].includes(operator.value))
    const dateOperators = getGridDateOperators().filter((operator) => ['after', 'before'].includes(operator.value))
    const choiceOperators = getGridSingleSelectOperators().filter((operator) => ['is', 'not'].includes(operator.value))
    const nullableChoiceOperators = [...choiceOperators, { value: 'is_empty', label: 'é vazio' }, { value: 'is_not_empty', label: 'não é vazio' }]
    const numericOperators = [...getGridNumericOperators().filter((operator) => ['=', '>', '>=', '<', '<='].includes(operator.value)), { value: 'is_empty', label: 'é vazio' }]
    const enterpriseFilterOperators = [...getGridStringOperators().filter((operator) => ['contains', 'equals'].includes(operator.value)), { value: 'is_empty', label: 'é vazio' }, { value: 'is_not_empty', label: 'não é vazio' }];

    const dynamicColumnsProperties = () => {

        const users_dict = Object.fromEntries(usersEmails.map(user => [user.id, `${user.first_name} ${user.last_name}`]))

        const properties = {
            'internal_code': { filterOperators: filterOperators },
            'name': { filterOperators: filterOperators, renderCell: ({ value, row }) => <Box sx={{ cursor: 'pointer' }} onClick={() => setProfile(row)}>{value}</Box> },
            'telephone': { filterOperators: filterOperators },
            'email': { filterOperators: filterOperators },
            'customer_code': { filterOperators: filterOperators },
            'enterprise_cnpj': { filterOperators: filterOperators },
            'advisor': { filterOperators: filterOperators },
            'contact_enterprise_name': { filterOperators: enterpriseFilterOperators },
            'owner_name': { filterOperators: choiceOperators, valueOptions: ['Público', ...Object.values(users_dict)] },
            'processedsurvey__nps': {filterOperators: numericOperators, valueGetter: ({row}) => row.processedsurvey?.nps},
            'processedsurvey__csat': {filterOperators: numericOperators, valueGetter: ({row}) => row.processedsurvey?.csat},
            'processedsurvey__number': {filterOperators: numericOperators, valueGetter: ({row}) => row.processedsurvey?.number},
            
            'created_at': {
                filterOperators: dateOperators,
                renderCell: (params) => (
                    <Box>
                        {params.value ? dayjs(params.value).utcOffset(-6).format('DD/MM/YYYY HH:mm') : ''}
                    </Box>
                )
            },
            'updated_at': {
                filterOperators: dateOperators,
                renderCell: (params) => (
                    <Box>
                        {params.value ? dayjs(params.value).utcOffset(-6).format('DD/MM/YYYY HH:mm') : ''}
                    </Box>
                )
            },
            'birthday': {
                filterOperators: dateOperators,
                renderCell: (params) => (
                    <Box>
                        {params.value ? dayjs(params.value).format('DD/MM/YYYY') : ''}
                    </Box>
                )
            },
            'last_communication_date': {
                filterOperators: dateOperators,
                renderCell: (params) => (
                    <Box>
                        {params.value ? dayjs(params.value).format('DD/MM/YYYY HH:mm') : ''}
                    </Box>
                )
            },
            'channels': {
                filterOperators: choiceOperators,
                valueOptions: ['WHATSAPP', 'TELEGRAM', 'INSTAGRAM', 'MESSENGER', 'EMAIL', 'MSTEAMS'],
                renderCell: (params) => {
                    if (getSession().profile.enterprise.contact_channels) {
                        return (
                            <Box className="clients-table-channels">
                                {params.row?.telephone && getSession().profile.enterprise?.has_voice &&
                                    <PhoneCallIcon className="action-button" sx={{ color: '#21446c' }}
                                        onClick={() => callContact(params.row.telephone)}
                                    />
                                }
                                {(getSession().profile?.enterprise?.platforms?.sms && params.row?.telephone) &&
                                    <SmsIcon className="action-button" sx={{ color: '#757575' }}
                                        onClick={() => setSingleClientSMSNotify([params.row.telephone])}
                                    />
                                }
                                {params.row.channels.toSorted((a, b) => b.channel.localeCompare(a.channel)).map(channel => {
                                    switch (channel.channel) {
                                        case 'WHATSAPP':
                                            return <WhatsAppIcon className="action-button" sx={{ color: '#34af23' }}
                                                onClick={() => setSingleClientWhatsAppNotify(params.row.id)}
                                            />
                                        case 'TELEGRAM':
                                            return <TelegramIcon className="action-button" sx={{ color: '#3390ec' }} />
                                        case 'INSTAGRAM':
                                            return <InstagramIcon className="action-button" sx={{ color: '#fd6b10' }} />
                                        case 'EMAIL':
                                            return <EmailIcon className="action-button" sx={{ color: '#757575' }}
                                                onClick={() => setSingleClientEmailNotify(params.row.id)}
                                            />
                                        case 'MESSENGER':
                                            return <FacebookIcon className="action-button" sx={{ color: '#0866ff' }} />
                                    }
                                })}
                            </Box>
                        )
                    }
                    return
                    (
                        <>
                            {'telephone' in params.row && params.row.telephone &&
                                <WhatsAppIcon sx={{ color: '#34af23', marginRight: '0.25rem' }} />
                            }
                            {'telegram_id' in params.row && params.row.telegram_id &&
                                <TelegramIcon sx={{ color: '#3390ec', marginRight: '0.25rem' }} />
                            }
                            {'msteams_id' in params.row && params.row.msteams_id &&
                                <MicrosoftIcon sx={{ color: '#6264A7', marginRight: '0.25rem' }} />
                            }
                            {'instagram_id' in params.row && params.row.instagram_id &&
                                <InstagramIcon sx={{ color: '#FD6B10', marginRight: '0.25rem' }} />
                            }
                            {'email' in params.row && params.row.email &&
                                <EmailIcon sx={{ color: '#757575', marginRight: '0.25rem' }} />
                            }
                            {'messenger_id' in params.row && params.row.messenger_id &&
                                <FacebookIcon sx={{ color: '#0866ff', marginRight: '0.25rem' }} />
                            }
                        </>
                    )
                }
            },
            'notification_opt_out': {
                filterOperators: choiceOperators,
                valueOptions: ['Sim', 'Não'],
                valueGetter: ({ value }) => {
                    return (value) ? 'Não' : 'Sim'
                }
            },
            'no_disturb': {
                filterOperators: choiceOperators,
                valueOptions: ['Sim', 'Não'],
                renderCell: ({ value }) => Boolean(value) ? 'Sim' : 'Não'
            },
            'groups': {
                filterOperators: filterOperators,
                valueGetter: ({ value }) => {
                    if (value)
                        return value.map(each => each.name).join()
                    return ''
                },
                renderCell: (params) => {
                    const groups = Array.isArray(params.row.groups) ? params.row.groups : []
                    const enterpriseGroups = Array.isArray(params.row.enterprise_groups) ? params.row.enterprise_groups : []

                    const uniqueGroups = [...groups, ...enterpriseGroups].reduce((acc, group) => {
                        acc.set(group.id, group)
                        return acc
                    }, new Map()).values()

                    return (
                        <>
                            {Array.from(uniqueGroups).map((group) => {
                                const isEnterprise = enterpriseGroups.some(e => e.id === group.id);
                                return (
                                    <GroupBadge
                                        key={group.id}
                                        onClick={() => filterOnClick(group.name, group.id)}
                                        className="client-group-item pointer"
                                        label={group.name}
                                        isEnterprise={isEnterprise}
                                    />
                                )
                            })}
                        </>
                    )
                }
            },
            'action': {
                width: 250,
                renderCell: (params) => {
                    const disabled = (typeof params.id === "string" && params.id.includes("auto-generated"))
                    return (
                        <Box className="action-buttons-container">
                            {/*<Tooltip title="Histórico de contatos" interactive>
                                <Button className="action-button"
                                    onClick={() => { setShowChats(params.row) }}
                                    size="large"
                                    disabled={disabled}>
                                    <ReceiptIcon />
                                </Button>
                            </Tooltip>*/}
                            {getSession().profile.enterprise.show_agenda &&
                                <Tooltip title="Criar Evento" interactive>
                                    <Button className="action-button"
                                        onClick={() => { setShowCreateEvent(true); setSelectedContact(params.row) }}>
                                        <EventIcon />
                                    </Button>
                                </Tooltip>
                            }
                            {getSession().profile.enterprise.contact_channels &&
                                <Tooltip title="Canais" interactive>
                                    <Button className="action-button"
                                        onClick={canChange() ? () => { setShowEditChannelDialog(params.row) } : () => { notifyNoPermission() }}
                                        disabled={disabled}>
                                        <DisplaySettingsIcon />
                                    </Button>
                                </Tooltip>
                            }
                            {canCreateOpportunity() &&
                                <Tooltip title="Nova Oportunidade" interactive>
                                    <Button className="action-button"
                                        onClick={() => { 
                                            setSelectedContact(params.row);
                                            setShowCreateOpportunity(true);
                                        }}
                                        disabled={disabled}>
                                        <WorkIcon />
                                    </Button>
                                </Tooltip>
                            }
                            <Tooltip title="Editar" interactive>
                                <Button className="action-button"
                                    onClick={canChange() ? () => { setProfile(params.row) } : () => { notifyNoPermission() }}
                                    disabled={disabled}>
                                    <EditIcon />
                                </Button>
                            </Tooltip>
                            <Tooltip title="Excluir" interactive>
                                <Button className={(disabled) ? "action-button" : "action-button delete"}
                                    onClick={canChange() ? () => { showDeleteClientDialog(params.row) } : () => { notifyNoPermission() }}
                                    disabled={disabled}>
                                    <DeleteIcon />
                                </Button>
                            </Tooltip>
                        </Box>
                    )
                }
            }
        }

        for (const field of customFields) {
            const settings = {
                renderCell: (params) => {
                    for (const contactField of params.row.custom_fields)
                        if (contactField.custom_field.field_name == field.field_name) {
                            if (contactField.custom_field.field_type == 'boolean')
                                return renderBooleanCustomField(contactField.value)
                            return contactField.value
                        }
                    return
                }
            }
            if (field.field_type === 'integer') {
                settings['filterOperators'] = numericOperators
            }
            if (field.field_type === 'boolean') {
                settings['filterOperators'] = nullableChoiceOperators
                settings['valueOptions'] = ['Sim', 'Não']
            }
            properties[`custom_${field.field_name}`] = settings
        }

        return properties
    }

    const getColumns = (hideEnterprise = false) => {
        const columns = applyGridLayoutToColumns(getDefaultColumns());

        if (hideEnterprise) {
            const enterpriseColumn = columns.find(
                (column) => column.field === 'contact_enterprise_name'
            );

            if (enterpriseColumn)
                enterpriseColumn.hide = true;
        }

        return columns;
    }

    const getDefaultColumns = () => {
        let columns = [
            { field: 'name', headerName: 'Nome', flex: 1, sortable: sortable, renderCell: ({ value, row }) => <Box sx={{ cursor: 'pointer' }} onClick={() => setProfile(row)}>{value}</Box> },
            { field: 'telephone', headerName: 'Telefone', flex: 1, sortable: sortable },
            { field: 'email', headerName: 'Email', flex: 1, sortable: sortable, hide: isSmallScreen },
            { field: 'customer_code', headerName: 'Código', flex: 1, sortable: sortable, hide: isSmallScreen, hide: true },
            { field: 'internal_code', headerName: 'Código interno (KID)', flex: 1, hide: true },
            { field: 'contact_enterprise_name', headerName: 'Empresa', flex: 1, hide: true, sortable: sortable },
            { field: 'cpf', headerName: 'CPF', flex: 1, hide: true, sortable: sortable },
            { field: 'created_at', type: 'dateTime', headerName: 'Criação', flex: 1, sortable: sortable, hide: isSmallScreen },
            { field: 'updated_at', type: 'dateTime', headerName: 'Última atualização', flex: 1, sortable: sortable, hide: true },
            { field: 'birthday', type: 'dateTime', headerName: 'Aniversário', flex: 1, sortable: sortable, hide: true },
            {
                field: 'linkedin_url',
                headerName: 'LinkedIn',
                flex: 1,
                hide: true,
                renderCell: (params) => {
                    const value = params.row.linkedin_url;
                    const href = normalizeHttpUrl(value);
    
                    if (!href) return '';
    
                    return (
                        <Link
                            href={href}
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="hover"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {value}
                        </Link>
                    );
                }
            },
            { field: 'last_communication_date', type: 'dateTime', headerName: 'Último contato', flex: 1, sortable: sortable, hide: true },
            { field: 'channels', headerName: 'Canais', flex: 0.75, sortable: false },
            { field: 'owner_name', headerName: 'Dono', flex: 0.75, sortable: false },
            { field: 'processedsurvey__nps', headerName: 'NPS', flex: 0.75, sortable: false, valueGetter: ({row}) => row.processedsurvey?.nps },
            { field: 'processedsurvey__csat', headerName: 'CSAT', flex: 0.75, sortable: false, valueGetter: ({row}) => row.processedsurvey?.csat },
            { field: 'processedsurvey__number', headerName: 'Pesquisa', flex: 0.75, sortable: false, valueGetter: ({row}) => row.processedsurvey?.number },
            { field: 'notification_opt_out', headerName: 'Recebe campanhas', flex: 0.5, hide: true, sortable: false,  },
            { field: 'no_disturb', headerName: 'Não perturbar', flex: 0.5, hide: true, sortable: false, renderCell: ({ value }) => Boolean(value) ? 'Sim' : 'Não' }
        ];

        if (settings.is_financial_market_company && permissions.isAdmin)
            columns.push({ field: 'advisor', headerName: 'Assessor', flex: 1, sortable: sortable });

        if (clients.length != 0 && 'user_fields' in clients[0]) {
            // Zendesk organization field
            columns.push({ field: 'organization_id', headerName: 'Organização', flex: 1, sortable: sortable, hide: isSmallScreen });
            // Zendesk integration custom fields
            Object.keys(clients[0].user_fields).forEach((field) => {
                const headerName = this.capitalize(field.replaceAll('_', ' '));
                columns.push({ field: field, headerName: headerName, flex: 1, sortable: sortable, hide: isSmallScreen });
            });
        }

        for (const custom of customFields)
            columns.push({ field: `custom_${custom.field_name}`, headerName: custom.field_name, hide: true, flex: 1, sortable: false })

        if (!isSmallScreen)
            columns.push({ field: 'groups', headerName: 'Segmentos', flex: 1, sortable: false })

        if (!isSmallScreen && getSession()?.profile?.enterprise?.platforms?.scout) {
            columns.push({
                field: 'category_assignments',
                headerName: 'Categoria (Scout)',
                flex: 1,
                sortable: false,
                renderCell: (params) => {
                    const assignments = params.row.category_assignments || [];
                    if (!assignments.length) return null;
                    return (
                        <Box sx={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                            {assignments.map((a) => (
                                <Tooltip
                                    key={a.scout_account_id}
                                    title={`Confiança: ${Math.round(a.confidence * 100)}% • Número: ${a.scout_account_phone_number}`}
                                >
                                    <Chip size="small" label={a.category_name} />
                                </Tooltip>
                            ))}
                        </Box>
                    );
                }
            });
        }

        if (!isSmallScreen)
            columns.push({ field: 'action', headerName: 'Ações', flex: 0.75, sortable: false, hide: false, filterable: false });

        return columns
    }

    const filterOnClick = (groupName, groupID) => {
        const newFilterModel = {
            items: [{
                columnField: 'groups',
                operatorValue: 'contains', value: String(groupName)
            }],
        }
        updateClientsFilter(newFilterModel)
        filterModel.clients = newFilterModel
        getClients('get', 25, 0, `&group_equal=${groupID}`)
    }

    const table = useMemo(() => {
        const theme = createTheme({
            palette: {
                primary: { main: '#21446C' },
            },
        }, ptBR, corePtBR);

        const CustomToolbar = () => {
            return (
                <GridToolbarContainer className={gridClasses.toolbarContainer}>
                    <Box className='toolbarLeft'>
                        <GridToolbarColumnsButton size="small" />
                        <GridToolbarFilterButton size="small" className={'filterControl'} />
                        <GridToolbarImportClients startIcon={<AddCircleIcon />}>
                            <AddClient groups={groups} customFields={customFields} usersEmails={usersEmails} />
                            {!isMobile() &&
                                <ImportClients usersEmails={usersEmails} />
                            }
                        </GridToolbarImportClients>
                        {!isMobile() &&
                            <>
                                <ClientGroupButton
                                    addclientgroup={handleAddClientGroupForm}
                                    deleteClientGroupModal={handleDeleteClientGroup}
                                    editClientGroupModal={handleEditClientGroup}
                                    selectedClientGroup={handleEditClientGroupMembers}
                                    filterOnClick={filterOnClick}
                                    small={isSmallScreen}
                                    selectedClients={selectedClients}
                                    addSelectedClientsToGroup={addSelectedClientsToGroup}
                                    loadMoreGroups={loadMoreGroups}
                                />
                                <LoadingButton
                                    component="label"
                                    startIcon={<GroupIcon />}
                                    loading={false}
                                    onClick={() => { checkShowMergeDialog() }}
                                    disabled={false}
                                    size="small"
                                >
                                    {isSmallScreen ? '' : 'Mesclar'}
                                </LoadingButton>
                            </>
                        }
                        {!isMobile() && selectedClients.length > 1 &&
                            <LoadingButton
                                component="label"
                                startIcon={<EditIcon />}
                                loading={false}
                                onClick={() => { updateMassBulkEditContactDialog(true) }}
                                disabled={false}
                                size="small"
                            >
                                {isSmallScreen ? '' : 'Editar selecionados'}
                            </LoadingButton>
                        }
                        {!isMobile() &&
                            <LoadingButton
                                component="label"
                                startIcon={<DeleteIcon />}
                                loading={false}
                                onClick={() => { updateMassDeleteClientDialog(true) }}
                                disabled={false}
                                size="small"
                            >
                                {isSmallScreen ? '' : 'Excluir'}
                            </LoadingButton>
                        }
                    </Box>
                    {!isMobile() &&
                        <Box className='toolbarRight'>
                            {/*<FormControlLabel 
                                control={<Switch checked={groupedByEnterprise} onClick={updateGroupedByEnterprise}/>} 
                                label="Agrupar por Empresa" 
                            />*/}
                            {permissions.isAdmin &&
                                <LoadingButton
                                    component="label"
                                    startIcon={<TableRowsIcon />}
                                    loading={false}
                                    onClick={() => setShowCustomFields(true)}
                                    disabled={false}
                                    size="small"
                                >
                                    {isSmallScreen ? '' : 'Campos Customizados'}
                                </LoadingButton>
                            }
                            <LoadingButton
                                component="label"
                                startIcon={<SettingsIcon />}
                                loading={false}
                                onClick={() => {
                                    localStorage.removeItem(GRID_LAYOUT_KEY);
                                    localStorage.removeItem(LEGACY_GRID_COLUMNS_KEY);

                                    if (groupedByEnterprise)
                                        updateGroupedByEnterprise();

                                    setClientsGridFilter(null);
                                    setClientsTableFilter(null);
                                    setDebouncedValue(null);
                                    setTableDebouncedValue(null);

                                    updateClientsFilter({ items: [] });
                                    filterModel.clients = { items: [] };
                                    getClients('filter', 25, 0, { items: [] });
                                }}
                                disabled={false}
                                size="small"
                            >
                                {isSmallScreen ? '' : 'Reset'}
                            </LoadingButton>
                        </Box>
                    }
                </GridToolbarContainer>
            )
        }

        //Treating mobile text
        const newlocaleText = theme.components.MuiDataGrid.defaultProps.localeText

        let mobileColumns = [];

        const handleColumnVisibilityChange = (updatedColumn) => {
            saveGridLayout({
                visibility: {
                    [updatedColumn.field]: updatedColumn.isVisible
                }
            });
        }

        const getPage = (limit, offset, direction) => {
            if (direction == 'next')
                return Math.round(offset / limit) - 1
            return Math.round(offset / limit) + 1

        }

        const getQueryset = (string, search, delimiter) => {
            const queryset = string.split(search)[1]
            if (queryset) {
                const result = queryset.split(delimiter)
                return result ? result[0] : ''
            }
            return ''
        }
        const getLimitOffset = (url) => {
            const queryset = url.split('?').pop()
            limit = getQueryset(queryset, 'limit=', '&')
            offset = getQueryset(queryset, 'offset=', '&')
            if (pageLimit)
                limit = pageLimit
            return [limit, offset]
        }

        const handlePageChange = (event) => {
            if (event > page) {
                getClients(...next)
                return
            }
            getClients(...previous)

        }

        const handlePageSizeChange = (newPage) => {
            updatePageLimit(newPage)
            getClients('auto', newPage, actual)
        }

        let count = 0
        let page = 0
        let next = ''
        let previous = ''
        let limit = 25
        let oldlimit = 0
        let offset = 0
        let actual = 0

        if (limitOffset.clients.length > 0) {
            limit = limitOffset.clients[0]
        }


        if (ServerData.clients) {
            count = ServerData.clients.count
            previous = ServerData.clients.previous
            next = ServerData.clients.next

            if (next) {
                const limitOffset = getLimitOffset(next)
                next = ['auto', ...limitOffset]
                page = getPage(...limitOffset, 'next')
                offset = limitOffset.pop()
                oldlimit = limitOffset.pop()
                actual = Number(offset) - Number(limit)
                updateLimitOffset(prevState => ({ ...prevState, clients: [oldlimit, actual] }))
            }

            if (previous) {
                const limitOffset = getLimitOffset(previous)
                previous = ['auto', ...limitOffset]
                if (!next) {
                    page = getPage(...limitOffset, 'previous')
                    offset = limitOffset.pop()
                    oldlimit = limitOffset.pop()
                    actual = Number(offset) - Number(limit)
                    updateLimitOffset(prevState => ({ ...prevState, clients: [oldlimit, actual] }))
                }

            }
        }

        const filterOnClick = (groupName, groupID) => {
            const newFilterModel = {
                items: [{
                    columnField: 'groups',
                    operatorValue: 'contains', value: String(groupName)
                }],
            }
            updateClientsFilter(newFilterModel)
            filterModel.clients = newFilterModel
            getClients('get', limit, offset - oldlimit, `&group_equal=${groupID}`)
        }

        const handleFilterChange = (event) => {
            const currentFilter = (event.items || []).find((item) => item?.columnField || item?.field)
            const currentField = currentFilter?.columnField || currentFilter?.field || "name"
            const previousFilter = (clientsFilter.items || []).find((item) => item?.columnField || item?.field)
            const previousField = previousFilter?.columnField || previousFilter?.field || "name"
            if (currentField !== previousField)
                setFilterPlaceholderField(currentField)
            getClients('filter', limit, actual, event)
            updateClientsFilter(event)
        }

        const handleSortChange = event => {
            getClients('sort', limit, actual, { items: [] }, event)
            updateClientsSort(event)
        }

        const changeNumberSelectionModel = newModel => {
            const addedNumbers = newModel.filter(each => !selectedClients.includes(each))
            const removedNumbers = selectedClients.filter(each => !newModel.includes(each))
            const added_phones = clients.filter(each => addedNumbers.includes(each.id)).map(each => each.telephone)
            const removed_phones = clients.filter(each => removedNumbers.includes(each.id)).map(each => each.telephone)
            let new_list = [...selectedNumberModel, ...added_phones]
            new_list = new_list.filter(each => !removed_phones.includes(each))
            updateNumberSelectedModel(new_list)
        }

        const updateGroupedByEnterprise = () => {
            if (!groupedByEnterprise)
                clients.forEach((client) => {
                    const enterpriseName = Array.isArray(client.enterprise_name)
                        ? client.enterprise_name[0]
                        : client.enterprise_name
                    client.enterprise_name = [enterpriseName || '', client.id]
                })
            else
                clients.forEach((client) => {
                    const enterpriseName = Array.isArray(client.enterprise_name)
                        ? client.enterprise_name[0]
                        : client.enterprise_name
                    client.enterprise_name = enterpriseName
                })
            setGroupedByEnterprise(!groupedByEnterprise)
        }

        const getTreeDataPath: DataGridProProps['getTreeDataPath'] = (row) => {
            if (Array.isArray(row.enterprise_name))
                return row.enterprise_name
            return [row.enterprise_name, Math.random()]
        }

        const groupingColDef: DataGridProProps['groupingColDef'] = {
            headerName: 'Empresa',
            renderCell: (params) => <CustomGridTreeDataGroupingCell {...params} />,
        };

        return (
            <Box sx={{ width: '100%', height: '100%' }}>
                <ThemeProvider theme={theme}>
                    <DataGridPro
                        apiRef={apiRef}
                        columns={getColumns(groupedByEnterprise)}
                        rows={clients}
                        checkboxSelection
                        disableSelectionOnClick
                        selectionModel={selectedClients}
                        components={{ Toolbar: CustomToolbar }}
                        onSelectionModelChange={(newSelectionModel) => {
                            updateSelectedClients(newSelectionModel);
                            changeNumberSelectionModel(newSelectionModel)
                        }}
                        density={'compact'}
                        localeText={
                            isSmallScreen
                                ? { ...newlocaleText, toolbarFilters: '', toolbarColumns: '' }
                                : newlocaleText
                        }
                        onColumnVisibilityChange={handleColumnVisibilityChange}
                        onColumnWidthChange={(params) => {
                            saveGridLayout({
                                widths: {
                                    [params.colDef.field]: params.width
                                }
                            });
                        }}
                        pagination
                        paginationMode="server"
                        rowsPerPageOptions={[25, 50, 100]}
                        page={page}
                        onPageSizeChange={handlePageSizeChange}
                        onPageChange={handlePageChange}
                        rowCount={count}
                        keepNonExistentRowsSelected
                        initialState={{
                            pagination: {
                                pageSize: Number(limit)
                            }
                        }}
                        filterMode={groupedByEnterprise ? "client" : "server"}
                        onFilterModelChange={handleFilterChange}
                        filterModel={clientsFilter}
                        sortingMode={groupedByEnterprise ? "client" : "server"}
                        sortModel={clientsSort}
                        onSortModelChange={handleSortChange}
                        treeData={groupedByEnterprise}
                        getTreeDataPath={getTreeDataPath}
                        groupingColDef={groupingColDef}
                        key={`clients-table-key-${groupedByEnterprise}`}
                    />
                </ThemeProvider>
            </Box>
        )
    }, [clients, isSmallScreen, forceReload, pageLimit, columnVisibilityModel, clientsFilter, selectedClients, groupedByEnterprise, usersEmails, profile])

    useEffect(() => {
        if (!loadMoreGrid || !nextClientsGrid) return
        api.get(`api/${nextClientsGrid.split("/api/")[1]}`).then((response) => {
            setLoadMoreGrid(false)
            if (response.status === 200) {
                setClientsGrid((prevClients) => [...prevClients, ...response.data["results"]])
                setNextClientsGrid(response.data["next"])
            }
        }).catch((err) => setLoadMoreGrid(false))
    }, [loadMoreGrid])

    const handleScroll = (event) => {
        const { scrollTop, scrollHeight, clientHeight } = event.target
        if (!loadMoreGrid && scrollHeight - scrollTop <= clientHeight + 100)
            setLoadMoreGrid(true)
    }

    const grid = useMemo(() => {
        return (
            <Box className="clients-grid-container" onScroll={handleScroll}>
                <Box className="clients-grid-container-flex">
                    {clientsGrid !== null &&
                        clientsGrid.map((client, index) => (
                            <ContactCard client={client}
                                onClick={() => setProfile(client)}
                                onTelephoneClick={() => setSingleClientWhatsAppNotify([client.id])}
                                onEmailClick={() => setSingleClientEmailNotify(client.id)}
                                onRemoveClick={() => showDeleteClientDialog(client)}
                            />
                        ))
                    }
                    {nextClientsGrid &&
                        [...Array(5)].map((_, index) => (
                            <Skeleton
                                className="skeleton-contact-card"
                                variant="rectangular"
                            />
                        ))
                    }
                </Box>
            </Box>
        )
    }, [clientsGrid, nextClientsGrid, profile])

    useEffect(() => {
        if (selectedView === "grid" && clientsGrid === null)
            getClientsGrid()
    }, [selectedView, clientsGrid])

    useEffect(() => {
        if (clientsGridFilter !== null) {
            const handler = setTimeout(() => {
                setDebouncedValue(clientsGridFilter)
            }, 1000)
            return () => clearTimeout(handler)
        }
    }, [clientsGridFilter])

    useEffect(() => {
        if (debouncedValue !== null)
            getClientsGrid(debouncedValue)
    }, [debouncedValue])

    useEffect(() => {
        if (clientsTableFilter !== null) {
            const handler = setTimeout(() => {
                setTableDebouncedValue(clientsTableFilter)
            }, 1000)
            return () => clearTimeout(handler)
        }
    }, [clientsTableFilter])

    useEffect(() => {
        if (tableDebouncedValue !== null) {
            const newFilterModel = {
                items: [{
                    columnField: filterPlaceholderField,
                    operatorValue: "contains",
                    value: tableDebouncedValue
                }]
            }
            updateClientsFilter(newFilterModel)
            filterModel.clients = newFilterModel
            getClients('filter', 25, 0, newFilterModel)
        }
    }, [tableDebouncedValue, filterPlaceholderField])

    const getClientsGrid = (search = null) => {
        let filter = { items: [] }
        if (search)
            filter["items"].push({
                columnField: "name",
                operatorValue: "contains",
                value: search
            })
        api.get(`api/enterprises/${getSession().profile.enterprise.id}/contacts/`, {
            params: {
                limit: 25,
                offset: 0,
                ...parseFilters(filter),
                ...parseSort([{ field: "name", sort: "desc" }])
            },
            paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" })
        }).then((response) => {
            setLoadMoreGrid(false)
            if (response.status === 200) {
                setClientsGrid(response.data["results"])
                setNextClientsGrid(response.data["next"])
            }
        }).catch((err) => { })
    }

    const clientDial = useMemo(() => {
        return (
            <>
                {
                    editClientDialog &&
                    <ClientDialog open={true}
                        title="Cliente"
                        type="change"
                        is_financial_market_company={settings.is_financial_market_company}
                        model={selectedClientModel}
                        key={selectedClientModel.id}
                        buttonText="Salvar"
                        handleClose={() => { updateSelectedClientModel([]); updateEditClientDialog(false) }}
                        submit={changeClient}
                        isAdmin={permissions.isAdmin}
                        listOfUsers={usersEmails}
                        groups={groups}
                        customFields={customFields}
                    />}
            </>
        )
    }, [editClientDialog])

    const deleteDial = useMemo(() => {
        return (
            <ConfirmationDialog open={deleteClientDialog}
                title="Confirmação"
                description={
                    selectedClientModel.name || selectedClientModel.telephone
                        ? `Tem certeza que deseja excluir o cliente ${
                              selectedClientModel.name || selectedClientModel.telephone
                          }?`
                        : "Tem certeza que deseja excluir o cliente?"
                }
                handleClose={() => { updateSelectedClientModel([]); updateDeleteClientDialog(false) }}
                handleSubmit={() => { deleteClient(selectedClientModel); updateSelectedClientModel([]); updateDeleteClientDialog(false) }}
            />
        )
    }, [deleteClientDialog])

    const mergeSelectedClients = async (client1, client2, finalClient, finalCustomFields, selectedChannelIds = []) => {
        updateNumberSelectedModel([])
        updateReady(false)

        const payload = {}
        Object.keys(finalClient).forEach((key) => {
            if (['enterprise', 'created_at', 'updated_at', 'extra_fields'].includes(key))
                return
            if (key === 'groups') {
                payload[key] = [...new Set(finalClient[key].map((group) => group.id))]
                return
            }
            payload[key] = finalClient[key]
        })

        payload['selected_channel_ids'] = selectedChannelIds
        payload['require_channel_selection'] = true

        const res = await api.post(`api/enterprises/${enterpriseId}/contacts/${finalClient.id}/merge/`,
            { client1: client1, client2: client2, final_client: payload })
        updateReady(true)
        
        if (res.status === 200) {
            if (finalCustomFields) {
                const contactId = finalClient.id
                
                const existingFields = await api.get(`api/enterprises/${enterpriseId}/contacts/${contactId}/custom_fields/`)
                
                if (existingFields.status === 200) {
                    for (const field of existingFields.data) {
                        await api.delete(`api/enterprises/${enterpriseId}/contacts/${contactId}/custom_fields/${field.id}/`)
                    }
                }
                
                for (const [fieldId, value] of Object.entries(finalCustomFields)) {
                    if (value !== null && value !== undefined && value !== '') {
                        await api.post(`api/enterprises/${enterpriseId}/contacts/${contactId}/custom_fields/`, {
                            custom_field: fieldId,
                            value: String(value)
                        })
                    }
                }
            }
            
            updateMergeClientDialog(false)
            await getClients()
            useNotification(
                'Sucesso!',
                'Contatos mesclados com sucesso!',
                'success'
            );
            return
        }

        if (res.status === 409) {
            const conflictedChannels = res.data?.conflicted_channels || []
            const conflictMessage = conflictedChannels.length
                ? `Selecione pelo menos um canal para os tipos: ${conflictedChannels.join(', ')}`
                : 'Existem conflitos de canais. Selecione os canais e tente novamente.'

            useNotification(
                'Atenção!',
                conflictMessage,
                'warning'
            );
            return
        }
        
        updateMergeClientDialog(false)
        useNotification(
            'Ops!',
            'Algo deu errado, tente novamente...',
            'danger'
        );

    }

    const mergeClient = useMemo(() => {
        return (
            <MergeClientDialog open={mergeClientDialog}
                clients={clients}
                selectedClients={selectedClients}
                customFields={customFields}
                handleClose={() => updateMergeClientDialog(false)}
                handleSubmit={mergeSelectedClients}
            />
        )
    }, [mergeClientDialog])

    const deleteAllDial = useMemo(() => {
        return (
            <ConfirmationDialog open={massDeleteClientDialog}
                title="Confirmação"
                description="Tem certeza que deseja excluir os contatos selecionados?"
                handleClose={() => { updateMassDeleteClientDialog(false) }}
                handleSubmit={() => { deleteClients(); updateMassDeleteClientDialog(false); updateSelectedClients([]) }}
            />
        )

    }, [massDeleteClientDialog])

    const addDial = useMemo(() => {
        return (
            <AddClientGroupForm
                selectionIds={selectedClientModel}
                enterpriseId={enterpriseId}
                open={showAddClientGroupForm}
                handleClose={() => { updateShowAddClientGroupForm(false); }}
                submit={submitClientGroupForm}
                updateClients={updateClients}
                updateGroups={updateGroups}
                subsObj={subsObj}
                clients={clients}
                updateForceReload={updateForceReload}
                updateReady={updateReady}
            />
        )

    }, [showAddClientGroupForm])

    const confirmGroupDial = useMemo(() => {
        return (
            <ConfirmationDialog open={deleteClientGroupModal}
                title="Confirmação"
                description="Tem certeza que deseja excluir o segmento selecionado?"
                handleClose={() => { updateDeleteClientGroupModal(false); }}
                handleSubmit={submitDeleteClientGroupModal}
            />
        )

    }, [deleteClientGroupModal])

    const uniqueConstraintError = (response) => {
        const key = 'non_field_errors'
        const message = 'The fields enterprise, field_name must make a unique set.'
        return (response.status === 400 && key in response.data && response.data[key][0] === message)
    }

    const submitCustomFields = async (toUpdateFields, toCreateFields, toDeleteFields) => {
        updateReady(false)
        let hasError = false
        if (toDeleteFields.length !== 0) {
            for (const id of toDeleteFields) {
                await api.delete(`api/enterprises/${enterpriseId}/custom_fields/${id}/`)
                localStorage.removeItem(GRID_LAYOUT_KEY);
                localStorage.removeItem(LEGACY_GRID_COLUMNS_KEY);
                if (groupedByEnterprise)
                    updateGroupedByEnterprise();
            }
        }
        if (toUpdateFields.length !== 0) {
            for (const field of toUpdateFields) {
                const patchResponse = await api.patch(`api/enterprises/${enterpriseId}/custom_fields/${field.id}/`, field)
                if (uniqueConstraintError(patchResponse) && !hasError) {
                    hasError = true
                    useNotification(
                        'Ops!',
                        'Os nomes dos campos customizados devem ser únicos!',
                        'danger'
                    )
                }
                localStorage.removeItem(GRID_LAYOUT_KEY);
                localStorage.removeItem(LEGACY_GRID_COLUMNS_KEY);;
                if (groupedByEnterprise)
                    updateGroupedByEnterprise();
            }
        }
        if (toCreateFields.length !== 0) {
            for (const field of toCreateFields) {
                const postResponse = await api.post(`api/enterprises/${enterpriseId}/custom_fields/`, field)
                if (uniqueConstraintError(postResponse) && !hasError) {
                    hasError = true
                    useNotification(
                        'Ops!',
                        'Os nomes dos campos customizados devem ser únicos!',
                        'danger'
                    )
                }
                localStorage.removeItem(GRID_LAYOUT_KEY);
                localStorage.removeItem(LEGACY_GRID_COLUMNS_KEY);;
                if (groupedByEnterprise)
                    updateGroupedByEnterprise();
            }
        }
        updateReady(true)
        updateMergeClientDialog(false)
        if (!hasError)
            useNotification(
                'Sucesso!',
                'Campos customizados atualizados com sucesso!',
                'success'
            );
        await getCustomFields()
        await getClients()
    }

    const customFieldsDialog = useMemo(() => {
        return (
            <CustomFieldsDialog open={showCustomFields}
                customFields={customFields}
                handleClose={() => setShowCustomFields(false)}
                handleSubmit={submitCustomFields}
            />
        )

    }, [showCustomFields])

    const editNameDial = useMemo(() => {
        return (
            <EditGroupNameModal
                open={editClientGroupModal}
                title="Editar Segmento"
                buttonText="Salvar"
                groups={groups}
                handleClose={(e) => { updateEditClientGroupModal(false); }}
                submit={submitEditModal}
                enterpriseId={enterpriseId}
                selectedGroup={selectedClientGroup}

            />
        )
    }, [editClientGroupModal])

    const editMembersDial = useMemo(() => {
        return (
            <EditGroupMembersModal
                open={editGroupMembersModal}
                title="Editar Segmento"
                buttonText="Salvar"
                groups={groups}
                handleClose={() => { updateEditGroupMembersModal(false); }}
                submit={() => { submitEditModal(); getClients() }}
                clients={clients}
                enterpriseId={enterpriseId}
                selectedGroup={selectedClientGroup}
                updateForceReload={updateForceReload}
            />
        )
    }, [editGroupMembersModal])

    const checkShowMergeDialog = () => {
        if (selectedClients.length !== 2) {
            useNotification(
                'Atenção!',
                'Selecione 2 contatos na tabela para mesclar!',
                'warning'
            );
            return
        }
        updateMergeClientDialog(true)
    }

    const createEvent = async (data) => {
        const response = await api.post(`api/enterprises/${getSession().profile.enterprise.id}/tasks/`, {
            ...data,
            target_date: dayjs(data.target_date).format("YYYY-MM-DDTHH:mm"),
            contact: (data.contact) ? data.contact.id : null,
            contact_enterprise: (data.contact_enterprise) ? data.contact_enterprise.id : null,
            owner: getSession().id,
            status: "SCHEDULED",
            target: (!data.target) ? getSession().id : data.target,
            is_recurrent: (data.is_recurrent === "UNIQUE") ? "" : data.is_recurrent
        })
        if (response.status === 201) {
            setShowCreateEvent(false)
            setSelectedContact(null)
            await useNotification(
                "Sucesso",
                "Tarefa criada com sucesso.",
                "success"
            )
            return
        }
        await useNotification(
            "Ops",
            "Algo deu errado, tente novamente.",
            "danger"
        )
    }

    return (
        <>
            <TextField
                variant="outlined"
                size="small"
                value={(selectedView !== "grid") ? clientsTableFilter : clientsGridFilter}
                placeholder={getFilterInputPlaceholderByField((selectedView !== "grid") ? filterPlaceholderField : "name", getDefaultColumns())}
                onChange={(event) => {
                    if (selectedView !== "grid")
                        setClientsTableFilter(event.target.value)
                    else
                        setClientsGridFilter(event.target.value)
                }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                }}
                className={(selectedView !== "grid") ? "client-grid-search-text-field m-left" : "client-grid-search-text-field"}
            />

            {selectedView === "table" ? table : grid}
            {editClientDialog && clientDial}
            {deleteClientDialog && deleteDial}
            {massDeleteClientDialog && deleteAllDial}
            {massBulkEditContactDialog &&
                <BulkEditContactDialog
                    open={massBulkEditContactDialog}
                    handleClose={() => updateMassBulkEditContactDialog(false)}
                    handleSubmit={bulkUpdateContacts}
                    customFields={customFields}
                    listOfUsers={usersEmails}
                />
            }
            {mergeClientDialog && mergeClient}
            {showChats && <UserChats data={showChats} handleClose={() => setShowChats(null)} />}
            {showEditChannelDialog && <ContactChannels data={showEditChannelDialog} handleClose={() => setShowEditChannelDialog(null)} />}

            <Box onClick={e => e.stopPropagation()}>
                {showAddClientGroupForm && addDial}
                {deleteClientGroupModal && confirmGroupDial}
                {editClientGroupModal && editNameDial}
                {editGroupMembersModal && editMembersDial}
                {showCustomFields && customFieldsDialog}
            </Box>

            {showCreateEvent &&
                <Event
                    open={showCreateEvent}
                    title="Criar evento"
                    handleClose={() => { setShowCreateEvent(false); setSelectedContact(null) }}
                    handleSubmit={createEvent}
                    isSupervisor={userGroups.isSupervisor}
                    myTeam={myTeam}
                    selectedEvent={{ contact_data: selectedContact }}
                    setProfile={() => { }}
                    setupWhatsAppNotify={(_, set) => { setSingleClientWhatsAppNotify(selectedContact.id); setSetup(p => set) }}
                    setupSMSNotify={(_, set) => { setSingleClientSMSNotify([selectedContact.telephone]); setSetup(p => set) }}
                    setupEmailNotify={(_, set) => { setSingleClientEmailNotify(selectedContact.id); setSetup(p => set) }}
                    lock
                />
            }
            {singleClientWhatsAppNotify &&
                <Templates
                    title={setup ? "Configurar notificação de whatsapp" : "Enviar whatsapp ao contato"}
                    open={singleClientWhatsAppNotify}
                    templates={templates}
                    queues={queues}
                    clients={clients}
                    selectionIds={[singleClientWhatsAppNotify]}
                    originNumbers={originNumbers}
                    handleClose={() => { setSingleClientWhatsAppNotify(null); setSetup(null) }}
                    handlePostSuccess={() => { }}
                    setup={setup}
                />
            }

            {singleClientEmailNotify &&
                <SendEmail
                    title={setup ? "Configurar notificação de e-mail" : "Enviar e-mail ao contato"}
                    queues={queues}
                    clients={[singleClientEmailNotify]}
                    handleClose={() => { setSingleClientEmailNotify(null); setSetup(null) }}
                    setup={setup}
                    canCopy={true}
                />
            }

            {singleClientSMSNotify &&
                <SendSMS
                    queues={queues}
                    selectedNumberModel={singleClientSMSNotify}
                    handleClose={() => { setSingleClientSMSNotify(null); setSetup(null) }}
                    title={setup ? "Configurar notificação de sms" : "Enviar SMS ao contato"}
                    setup={setup}
                />}

            <OpportunityByContact
                open={showCreateOpportunity}
                contact={selectedContact}
                onClose={() => {
                    setShowCreateOpportunity(false)
                    setSelectedContact(null)
                }}
                enterpriseId={enterpriseId}
                usersEmails={usersEmails}
            />

        </>
    )
}

export default ClientsTable
